"use client"

/**
 * Import approach block for the profile menu (`use-import-approach`).
 *
 * Same placement argument as `QuestionSearchModeMenu` and
 * `AddQuestionsJourneyMenu`: a standing preference about how import finishes,
 * not a control the import sheet should spend its first viewport on.
 */

import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import {
  IMPORT_APPROACHES,
  setImportApproach,
  useImportApproach,
  type ImportApproach,
} from "@/hooks/use-import-approach"

export function ImportApproachMenu() {
  const approach = useImportApproach()
  const active = IMPORT_APPROACHES.find((option) => option.id === approach)

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <i className="fa-light fa-file-import" aria-hidden="true" />
        Import approach
        <span className="ms-auto pe-1 text-xs text-muted-foreground">
          {active?.label}
        </span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-72">
        <DropdownMenuRadioGroup
          value={approach}
          onValueChange={(value) =>
            setImportApproach(value as ImportApproach)
          }
        >
          {IMPORT_APPROACHES.map((option) => (
            <DropdownMenuRadioItem
              key={option.id}
              value={option.id}
              className="items-start gap-2 py-2"
            >
              <span className="flex flex-col gap-0.5">
                <span className="font-medium">{option.label}</span>
                <span className="text-xs leading-snug text-muted-foreground">
                  {option.description}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
